module.exports = __webpack_public_path__ + "media/images/common-nav/state-parks/florida-64c88a06e1b45987fe614b5ff09d0ea4.jpg";